import { useState } from 'react';

import { useDeviceType } from '@braskai/ui-kit';

import { DesktopNav } from '../DesktopNav';
import { SContainer, SDrawer } from './styled';

type DesktopSidebarProps = {
  lockedSidebar?: boolean;
  handleLockedSidebar?: () => void;
};

export const DesktopSidebar = ({ lockedSidebar, handleLockedSidebar }: DesktopSidebarProps) => {
  const { isDesktop, isLaptop } = useDeviceType();

  const [isOpen, setIsOpen] = useState(false);

  const onMouseEnter = () => {
    setIsOpen(true);
  };
  const onMouseLeave = () => {
    setIsOpen(false);
  };

  const handleLocked = () => {
    handleLockedSidebar?.();

    if (isOpen) {
      setIsOpen(false);
    }
  };

  if (!isDesktop && !isLaptop) {
    return null;
  }

  return (
    <SContainer $locked={lockedSidebar}>
      <SDrawer
        $hover={isOpen}
        $locked={lockedSidebar}
        variant="permanent"
        open
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <DesktopNav isOpen={isOpen} locked={lockedSidebar} handleLocked={handleLocked} />
      </SDrawer>
    </SContainer>
  );
};
